import { Button, Flex, Stack } from '@chakra-ui/react';
import { memo } from 'react';

import InventoryTable from '@features/inventory/InventoryTable';
import ProductStats from '@features/inventory/ProductStats';
import UnitOverview from '@features/inventory/UnitOverview';
import Plus from 'vectors/Plus';

interface Props {
  onClickPurchase: () => void;
}

const InventoryOverview = ({ onClickPurchase }: Props) => {
  return (
    <Flex flexDir="column" pb={2} gap={4} height="100%">
      <Button alignSelf="flex-end" size="xs" onClick={onClickPurchase}>
        <Plus />
        Purchase
      </Button>
      <ProductStats />
      <Stack direction={{ base: 'column', xl: 'row' }} gap={4}>
        <Flex flex={1}>
          <InventoryTable />
        </Flex>
        <Flex minW={{ base: 'full', xl: 'md' }}>
          <UnitOverview />
        </Flex>
      </Stack>
    </Flex>
  );
};

export default memo(InventoryOverview);
